import StudentCareServices from '@/services/StudentCareServices';
import { SCHOOL_LEVEL } from '@/helpers/constant';

export default {
  data() {
    return {
      redoTestName: '',
      MODULE: {
        BLENDED: 'blended',
        TUTOR: 'tutor',
      },
      isShowConfirmRedoPopup: false,
      REDO_TEST_PROGRAMS: ['Chương trình IELTS Tutoring'],
      redoTestInfo: {},
      TEST_TYPE_NAME: {
        1: 'Tất cả',
        2: 'Speaking',
        3: 'Listening',
        4: 'Reading',
        5: 'Writing',
      },
      TEST_TYPE: {
        TAT_CA: 1,
        SPEAKING: 2,
        LISTENING: 3,
        READING: 4,
        WRITING: 5,
      },
    };
  },
  methods: {
    async confirmRedoTest(callBack) {
      const loading = this.$loading.show();
      const res = await StudentCareServices.resetTestResult(this.redoTestInfo);
      loading.hide();
      if (res.success) {
        this.$swal({
          position: 'center',
          type: 'success',
          icon: 'success',
          text: 'Reset kết quả kiểm tra thành công !',
        });
      } else {
        this.$swal({
          position: 'center',
          type: 'error',
          icon: 'error',
          text: `Có lỗi khi thực hiện: ${res.message} !`,
        });
      }
      this.isShowConfirmRedoPopup = false;
      await callBack();
    },
    isShowRedoTest(item) {
      return (this.$route.query.schoolLevel === SCHOOL_LEVEL.SECONDARY || this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY)
        && this.REDO_TEST_PROGRAMS.includes(_.get(this.mapProgramIdAndProgram[item.curriculum_id || item.curriculumId], 'title', ''));
    },
    showConfirmRedoPopup(item, type, module, testName) {
      this.redoTestName = testName;
      this.redoTestInfo = {
        lesson_id: +item.lesson_id || +item.lessonId,
        lms_core_user_id: module === this.MODULE.TUTOR ? this.lmsCoreUserID : this.studentBlendedTutorDetail.lms_core_user_id,
        care_id: +this.$route.params.id,
        reset_type: type,
      };
      this.isShowConfirmRedoPopup = true;
    },
  },
};
